module.exports = __webpack_public_path__ + "static/media/image1.60d09afb.JPG";